export const menus: Menu[] = [
	{ id: 1, name: "menu.home", link: "/", hasSlug: true, show: true },
	{ id: 2, name: "menu.service", link: "/", hasSlug: false, show: true },

	{
		id: 9,
		name: "menu.solutions",
		link: "/industry",
		hasSlug: false,
		show: true,
		children: [
			{ id: 10, name: "solutions.automotive", link: "/industry/automotive", hasSlug: true, show: true },
			{
				id: 11,
				name: "solutions.medicalDevices",
				link: "/industry/medical-device",
				hasSlug: true,
				show: true,
			},
			{
				id: 12,
				name: "solutions.consumerElectronics",
				link: "/industry/consumer-electronics",
				hasSlug: true,
				show: true,
			},
			{ id: 13, name: "solutions.aerospace", link: "/industry/aerospace", hasSlug: true, show: true },
			{
				id: 14,
				name: "solutions.industrialEquipment",
				link: "/industry/industry-equipment",
				hasSlug: true,
				show: true,
			},
			{
				id: 141,
				name: "solutions.robotics-automation",
				link: "/industry/robotics-automation",
				hasSlug: true,
				show: true,
			},
			{ id: 142, name: "solutions.education", link: "/industry/education", hasSlug: true, show: true },
			{
				id: 143,
				name: "solutions.renewable-energy",
				link: "/industry/renewable-energy",
				hasSlug: true,
				show: true,
			},
			{
				id: 144,
				name: "solutions.communication",
				link: "/industry/communication",
				hasSlug: true,
				show: true,
			},
			{
				id: 145,
				name: "solutions.semiconductor",
				link: "/industry/semiconductor",
				hasSlug: true,
				show: true,
			},
			{
				id: 146,
				name: "solutions.consumer-goods",
				link: "/industry/consumer-goods",
				hasSlug: true,
				show: true,
			},
		],
	},
	{
		id: 30,
		name: "menu.materials",
		link: "/materials",
		hasSlug: false,
		show: true,
	},
	{
		id: 4,
		name: "menu.aboutUs",
		link: "/about-us",
		hasSlug: true,
		show: true,
	},
	{ id: 7, name: "menu.category", link: "/category", hasSlug: true, show: false },
	{ id: 8, name: "menu.tag", link: "/tag", hasSlug: true, show: false },
	{
		id: 15,
		name: "menu.resources",
		link: "/resource",
		hasSlug: false,
		show: true,
		children: [
			{ id: 3, name: "menu.blog", link: "/blog", hasSlug: true, show: true },
			{ id: 20, name: "menu.product", link: "/products", hasSlug: true, show: true },
			{ id: 16, name: "menu.whitePapers", link: "/white-papers", hasSlug: true, show: true },
			{ id: 21, name: "menu.quality", link: "/quality-assurance", hasSlug: true, show: true },
			{ id: 19, name: "resource.Cases", link: "/cases", hasSlug: true, show: true },
			{ id: 18, name: "resource.News", link: "/blog", hasSlug: true, show: true },
			{ id: 6, name: "menu.faqs", link: "/faqs", hasSlug: true, show: true },
		],
	},
	{ id: 5, name: "menu.contactUs", link: "/contact-us", hasSlug: true, show: true },
	{ id: 17, name: "menu.view3d", link: "/view-3d", hasSlug: true, show: false },
	{ id: 17, name: "menu.policy", link: "/policy", hasSlug: true, show: false },
];

export interface MenuItem {
	id: number;
	name: string;
	link: string;
	hasSlug: boolean;
	show: boolean;
}

export interface Menu {
	id: number;
	name: string;
	link: string;
	hasSlug: boolean;
	show: boolean;
	children?: MenuItem[];
}
